import React from 'react';
import PropTypes from 'prop-types';

const IconPlay2 = ({ color = '#ffffff', fill = color, ...otherProps }) => (
  <svg
    viewBox="0 0 11 14"
    role="presentation"
    aria-hidden="true"
    focusable="false"
    width="20px"
    height="20px"
    fill={fill}
    {...otherProps}
  >
    <path
      d="m0 .63c0-.51.57-.81.99-.52l9.64 6.17c.49.35.49 1.08 0 1.43l-9.64 6.17c-.42.3-.99 0-.99-.52z"
      fillRule="evenodd"
    />
  </svg>
);

IconPlay2.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
};

export default IconPlay2;
